var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center p-5"},[_vm._v(" Signing you in… ")])}
var staticRenderFns = []

export { render, staticRenderFns }